// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import API_URL from "../Config";
// import Swal from "sweetalert2";
// import start from "./icon/start.svg";
// import del from "./icon/delete.svg";
// import dayjs from "dayjs";

// const LiveStream = () => {
//   const navigate = useNavigate();

//   // ============================================================
//   // STATES
//   // ============================================================

//   const [streams, setStreams] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [deletingId, setDeletingId] = useState(null);

//   // ============================================================
//   // API ENDPOINTS
//   // ============================================================

//   const PRE_RECORDED_GET_API = `${API_URL}/api/live/schedule`;

//   // Change this if your webcam controller has @RequestMapping.
//   const WEBCAM_GET_API = `${API_URL}/get`;

//   const PRE_RECORDED_DELETE_API = `${API_URL}/api/live`;

//   // Replace with your actual webcam DELETE endpoint.
//   const WEBCAM_DELETE_API = `${API_URL}/api/streams/webcamlive`;

//   // ============================================================

//   // GET AUTH HEADERS
//   // ============================================================

//   const getAuthHeaders = () => {
//     const token = sessionStorage.getItem("tokenn");

//     return {
//       headers: {
//         ...(token ? { Authorization: token } : {}),
//       },
//     };
//   };

//   // ============================================================
//   // STATUS MAPPING
//   // ============================================================

//   const getPreRecordedStatus = (status) => {
//     switch (status) {
//       case "LIVE":
//         return "LIVE";

//       case "UPCOMING":
//         return "READY";

//       case "PUBLISHED":
//         return "PUBLISHED";

//       case "ENDED":
//         return "PUBLISHED";

//       default:
//         return status || "UNKNOWN";
//     }
//   };

//   const getWebcamStatus = (status) => {
//     switch (status) {
//       case "LIVE":
//         return "LIVE";

//       case "SCHEDULED":
//         return "READY";

//       case "ENDED":
//         return "PUBLISHED";

//       case "CANCELLED":
//         return "CANCELLED";

//       default:
//         return status || "UNKNOWN";
//     }
//   };

//   // ============================================================
//   // FETCH BOTH STREAM TYPES
//   // ============================================================

//   const fetchStreams = useCallback(async () => {
//     try {
//       const results = await Promise.allSettled([
//         axios.get(
//           `${API_URL}/api/live/schedule`,
//           getAuthHeaders()
//         ),

//         axios.get(
//           `${API_URL}/api/streams/get`,
//           getAuthHeaders()
//         ),
//       ]);

//       const [preRecordedResult, webcamResult] = results;

//       // ========================================================
//       // PRE-RECORDED STREAMS
//       // ========================================================

//       let preRecordedStreams = [];

//       if (preRecordedResult.status === "fulfilled") {
//         const response = preRecordedResult.value;

//         const list = Array.isArray(response.data)
//           ? response.data
//           : [];

//         preRecordedStreams = list.map((s) => ({
//           id: s.id,

//           uniqueId: `PRE-RECORDED-${s.id}`,

//           uploadType: "PRE-RECORDED",

//           streamTitle: s.streamTitle,

//           videoId: s.videoId,

//           scheduleStart: s.startTime,

//           scheduleEnd: s.endTime,

//           status: getPreRecordedStatus(s.status),

//           originalStatus: s.status,
//         }));
//       } else {
//         console.error(
//           "Error fetching pre-recorded streams:",
//           preRecordedResult.reason
//         );
//       }

//       // ========================================================
//       // WEBCAM STREAMS
//       // ========================================================

//       let webcamStreams = [];

//       if (webcamResult.status === "fulfilled") {
//         const response = webcamResult.value;

//         const list = Array.isArray(response.data)
//           ? response.data
//           : [];

//         webcamStreams = list.map((s) => ({
//           id: s.id,

//           uniqueId: `WEBCAM-${s.id}`,

//           uploadType: "WEBCAM",

//           streamTitle: s.title,

//           scheduleStart: s.scheduledStart,

//           scheduleEnd: s.scheduledEnd,

//           roomId: s.roomId,

//           adminId: s.adminId,

//           webcamSource: s.webcamSource,

//           status: getWebcamStatus(s.status),

//           originalStatus: s.status,
//         }));
//       } else {
//         console.error(
//           "Error fetching webcam streams:",
//           webcamResult.reason
//         );
//       }

//       // ========================================================
//       // COMBINE BOTH LISTS
//       // ========================================================

//       const combinedStreams = [
//         ...preRecordedStreams,
//         ...webcamStreams,
//       ];

//       // ========================================================
//       // SORT BY SCHEDULE START TIME
//       // ========================================================

//       combinedStreams.sort((a, b) => {
//         const dateA = dayjs(a.scheduleStart).valueOf();
//         const dateB = dayjs(b.scheduleStart).valueOf();

//         return dateB - dateA;
//       });

//       // ========================================================
//       // UPDATE STATE
//       // ========================================================

//       setStreams(combinedStreams);

//     } catch (error) {
//       console.error("Error fetching streams:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [API_URL]);

//   // ============================================================
//   // INITIAL FETCH AND AUTO REFRESH
//   // ============================================================

//   useEffect(() => {
//     fetchStreams();

//     const interval = setInterval(() => {
//       fetchStreams();
//     }, 15000);

//     return () => {
//       clearInterval(interval);
//     };
//   }, [fetchStreams]);

//   // ============================================================
//   // NAVIGATION
//   // ============================================================

//   const handleClick = (link) => {
//     localStorage.removeItem("items");

//     navigate(link);
//   };

//   // ============================================================
//   // HANDLE PLAY
//   // ============================================================

//   const handlePlay = (stream) => {
//     console.log("Selected Stream:", stream);

//     // ========================================================
//     // PRE-RECORDED VIDEO
//     // ========================================================

//     if (stream.uploadType === "PRE-RECORDED") {
//       window.open(
//         "/prerecordedlive",
//         "_blank",
//         "noopener,noreferrer"
//       );
//     }

//     // ========================================================
//     // WEBCAM LIVE STREAM
//     // ========================================================

//     else if (stream.uploadType === "WEBCAM") {
//       navigate(`/admin/weblive/${stream.id}`);
//     }
//   };

//   // ============================================================
//   // HANDLE DELETE
//   // ============================================================

//   const handleDelete = async (stream) => {
//     const confirm = await Swal.fire({
//       title: "Delete this stream?",
//       text: "If the stream is live, deleting it may stop broadcasting.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#d33",
//     });

//     if (!confirm.isConfirmed) {
//       return;
//     }

//     try {
//       setDeletingId(stream.uniqueId);

//       let deleteUrl = "";

//       // ========================================================
//       // PRE-RECORDED DELETE
//       // ========================================================

//       if (stream.uploadType === "PRE-RECORDED") {
//         deleteUrl = `${API_URL}/api/live/${stream.id}`;
//       }

//       // ========================================================
//       // WEBCAM DELETE
//       // ========================================================

//       else if (stream.uploadType === "WEBCAM") {
//         // Requires a matching Spring Boot @DeleteMapping.
//         deleteUrl = `${API_URL}/webcamlive/${stream.id}`;
//       }

//       if (!deleteUrl) {
//         throw new Error("Invalid stream type");
//       }

//       // ========================================================
//       // DELETE API CALL
//       // ========================================================

//       await axios.delete(deleteUrl, getAuthHeaders());

//       await Swal.fire({
//         icon: "success",
//         title: "Deleted!",
//         text: "Stream removed successfully.",
//       });

//       // Refresh after deletion
//       await fetchStreams();

//     } catch (error) {
//       console.error("Error deleting stream:", error);

//       Swal.fire({
//         icon: "error",
//         title: "Delete Failed",
//         text:
//           error.response?.data?.message ||
//           "Could not delete the stream.",
//       });

//     } finally {
//       setDeletingId(null);
//     }
//   };

//   // ============================================================
//   // FORMAT DATE
//   // ============================================================

//   const formatDate = (date) => {
//     if (!date || !dayjs(date).isValid()) {
//       return "-";
//     }

//     return dayjs(date).format("DD/MM/YYYY hh:mm A");
//   };

//   // ============================================================
//   // STATUS BADGE COLOR
//   // ============================================================

//   const getStatusClass = (status) => {
//     switch (status) {
//       case "LIVE":
//         return "bg-success";

//       case "READY":
//         return "bg-info";

//       case "PUBLISHED":
//         return "bg-warning";

//       case "CANCELLED":
//         return "bg-danger";

//       default:
//         return "bg-secondary";
//     }
//   };

//   // ============================================================
//   // JSX
//   // ============================================================

//   return (
//     <div className="marquee-container">

//       {/* ======================================================
//           UPLOAD CONTENT BUTTON
//       ======================================================= */}

//       <div className="AddArea">

//         <button
//           type="button"
//           className="btn btn-custom"
//           onClick={() =>
//             handleClick("/admin/upload-content")
//           }
//         >
//           Upload Content
//         </button>

//       </div>

//       <br />

//       <div className="container3">

//         {/* ====================================================
//             BREADCRUMB
//         ===================================================== */}

//         <ol className="breadcrumb mb-4 d-flex my-0">

//           <li className="breadcrumb-item text-white">
//             Stream Management
//           </li>

//         </ol>

//         <div className="outer-container">

//           <div className="table-container">

//             {/* ================================================
//                 STREAM MANAGEMENT TABLE
//             ================================================= */}

//             <table className="table table-striped">

//               <thead>

//                 <tr className="table-header">

//                   <th>
//                     <input type="checkbox" />
//                   </th>

//                   <th>ID</th>

//                   <th>SOURCE</th>

//                   <th>STREAM NAME</th>

//                   <th>START TIME</th>

//                   <th>END TIME</th>

//                   <th>STATUS</th>

//                   <th>ACTION</th>

//                 </tr>

//               </thead>

//               <tbody>

//                 {/* ============================================
//                     LOADING
//                 ============================================= */}

//                 {loading ? (

//                   <tr>

//                     <td
//                       colSpan="8"
//                       className="text-center"
//                     >
//                       Loading streams...
//                     </td>

//                   </tr>

//                 ) : streams.length > 0 ? (

//                   /* ==========================================
//                      DISPLAY BOTH STREAM TYPES
//                   =========================================== */

//                   streams.map((stream, index) => (

//                     <tr
//                       key={stream.uniqueId}
//                       className={
//                         index % 2 === 0
//                           ? "even-row"
//                           : "odd-row"
//                       }
//                     >

//                       {/* CHECKBOX */}

//                       <td>
//                         <input type="checkbox" />
//                       </td>

//                       {/* SERIAL NUMBER */}

//                       <td>
//                         {index + 1}
//                       </td>

//                       {/* SOURCE */}

//                       <td>
//                         {stream.uploadType}
//                       </td>

//                       {/* STREAM TITLE */}

//                       <td>
//                         {stream.streamTitle}
//                       </td>

//                       {/* START TIME */}

//                       <td>
//                         {formatDate(stream.scheduleStart)}
//                       </td>

//                       {/* END TIME */}

//                       <td>
//                         {formatDate(stream.scheduleEnd)}
//                       </td>

//                       {/* STATUS */}

//                       <td>

//                         <span
//                           className={`badge ${getStatusClass(
//                             stream.status
//                           )}`}
//                         >
//                           {stream.status}
//                         </span>

//                       </td>

//                       {/* ACTION BUTTONS */}

//                       <td>

//                         {/* PLAY BUTTON */}

//                         <button
//                           type="button"
//                           className="btn btn-sm me-2"
//                           onClick={() => handlePlay(stream)}
//                         >

//                           <img
//                             src={start}
//                             alt="start"
//                             style={{
//                               width: "30px",
//                               height: "30px",
//                             }}
//                           />

//                         </button>

//                         {/* DELETE BUTTON */}

//                         <button
//                           type="button"
//                           className="btn btn-sm"
//                           disabled={
//                             deletingId === stream.uniqueId
//                           }
//                           onClick={() =>
//                             handleDelete(stream)
//                           }
//                         >

//                           <img
//                             src={del}
//                             alt="delete"
//                             style={{
//                               width: "30px",
//                               height: "30px",
//                             }}
//                           />

//                         </button>

//                       </td>

//                     </tr>

//                   ))

//                 ) : (

//                   /* ==========================================
//                      NO STREAMS
//                   =========================================== */

//                   <tr>

//                     <td
//                       colSpan="8"
//                       className="text-center"
//                     >
//                       No streams found
//                     </td>

//                   </tr>

//                 )}

//               </tbody>

//             </table>

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default LiveStream;



import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../Config";
import Swal from "sweetalert2";
import start from "./icon/start.svg";
import del from "./icon/delete.svg";
import dayjs from "dayjs";

const LiveStream = () => {
  const navigate = useNavigate();

  // ============================================================
  // STATES
  // ============================================================

  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  // ============================================================
  // API ENDPOINTS
  // ============================================================

  const PRE_RECORDED_GET_API = `${API_URL}/api/live/schedule`;

  const WEBCAM_GET_API = `${API_URL}/api/streams/get`;

  const PRE_RECORDED_DELETE_API = `${API_URL}/api/live`;

  // Replace this with your actual webcam DELETE endpoint.
  const WEBCAM_DELETE_API = `${API_URL}/api/streams/webcamlive`;

  // ============================================================
  // AUTH HEADERS
  // ============================================================

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("tokenn");

    return {
      headers: {
        ...(token ? { Authorization: token } : {}),
      },
    };
  };

  // ============================================================
  // STATUS MAPPING
  // ============================================================

  const getPreRecordedStatus = (status) => {
    switch (status) {
      case "LIVE":
        return "LIVE";

      case "UPCOMING":
        return "READY";

      case "PUBLISHED":
        return "PUBLISHED";

      case "ENDED":
        return "PUBLISHED";

      default:
        return status || "UNKNOWN";
    }
  };

  const getWebcamStatus = (status) => {
    switch (status) {
      case "LIVE":
        return "LIVE";

      case "SCHEDULED":
        return "READY";

      case "ENDED":
        return "PUBLISHED";

      case "CANCELLED":
        return "CANCELLED";

      default:
        return status || "UNKNOWN";
    }
  };

  // ============================================================
  // FETCH BOTH STREAM TYPES
  // ============================================================

  const fetchStreams = useCallback(async () => {
    try {
      const token = sessionStorage.getItem("tokenn");

      const config = {
        headers: {
          ...(token ? { Authorization: token } : {}),
        },
      };

      // ========================================================
      // CALL BOTH APIs
      // ========================================================

      const results = await Promise.allSettled([
        axios.get(PRE_RECORDED_GET_API, config),
        axios.get(WEBCAM_GET_API, config),
      ]);

      const [preRecordedResult, webcamResult] = results;

      // ========================================================
      // PRE-RECORDED STREAMS
      // ========================================================

      let preRecordedStreams = [];

      if (preRecordedResult.status === "fulfilled") {
        const response = preRecordedResult.value;

        const list = Array.isArray(response.data)
          ? response.data
          : [];

        preRecordedStreams = list.map((s) => ({
          id: s.id,

          uniqueId: `PRE-RECORDED-${s.id}`,

          uploadType: "PRE-RECORDED",

          streamTitle: s.streamTitle,

          videoId: s.videoId,

          scheduleStart: s.startTime,

          scheduleEnd: s.endTime,

          status: getPreRecordedStatus(s.status),

          originalStatus: s.status,
        }));
      } else {
        console.error(
          "Error fetching pre-recorded streams:",
          preRecordedResult.reason
        );
      }

      // ========================================================
      // WEBCAM STREAMS
      // ========================================================

      let webcamStreams = [];

      if (webcamResult.status === "fulfilled") {
        const response = webcamResult.value;

        const list = Array.isArray(response.data)
          ? response.data
          : [];

        webcamStreams = list.map((s) => ({
          id: s.id,

          uniqueId: `WEBCAM-${s.id}`,

          uploadType: "WEBCAM",

          streamTitle: s.title,

          scheduleStart: s.scheduledStart,

          scheduleEnd: s.scheduledEnd,

          roomId: s.roomId,

          adminId: s.adminId,

          webcamSource: s.webcamSource,

          status: getWebcamStatus(s.status),

          originalStatus: s.status,
        }));
      } else {
        console.error(
          "Error fetching webcam streams:",
          webcamResult.reason
        );
      }

      // ========================================================
      // COMBINE BOTH LISTS
      // ========================================================

      const combinedStreams = [
        ...preRecordedStreams,
        ...webcamStreams,
      ];

      // ========================================================
      // SORT BY SCHEDULE START TIME
      // ========================================================

      combinedStreams.sort((a, b) => {
        const dateA = dayjs(a.scheduleStart).valueOf();
        const dateB = dayjs(b.scheduleStart).valueOf();

        return dateB - dateA;
      });

      // ========================================================
      // UPDATE STATE
      // ========================================================

      setStreams(combinedStreams);

    } catch (error) {
      console.error("Error fetching streams:", error);
    } finally {
      setLoading(false);
    }
  }, [PRE_RECORDED_GET_API, WEBCAM_GET_API]);

  // ============================================================
  // INITIAL FETCH AND AUTO REFRESH
  // ============================================================

  useEffect(() => {
    fetchStreams();

    const interval = setInterval(() => {
      fetchStreams();
    }, 15000);

    return () => {
      clearInterval(interval);
    };
  }, [fetchStreams]);

  // ============================================================
  // NAVIGATION
  // ============================================================

  const handleClick = (link) => {
    localStorage.removeItem("items");

    navigate(link);
  };

  // ============================================================
  // HANDLE PLAY BASED ON SOURCE TYPE
  // ============================================================

  const handlePlay = (stream) => {
    console.log("Selected Stream:", stream);

    // ========================================================
    // WEBCAM LIVE STREAM
    // ========================================================

    if (stream.uploadType === "WEBCAM") {
      console.log("Opening Webcam Live Stream");

      console.log("Webcam Stream ID:", stream.id);

      console.log("Room ID:", stream.roomId);

      navigate(`/admin/WebCamLive`, {
        state: {
          streamId: stream.id,
          roomId: stream.roomId,
          adminId: stream.adminId,
          streamTitle: stream.streamTitle,
          webcamSource: stream.webcamSource,
        },
      });

    }

    // ========================================================
    // PRE-RECORDED LIVE STREAM
    // ========================================================

    else if (stream.uploadType === "PRE-RECORDED") {
      console.log("Opening Pre-Recorded Live Stream");

      console.log("Pre-Recorded Stream ID:", stream.id);

      console.log("Video ID:", stream.videoId);

      navigate(`/prerecordedlive/${stream.id}`, {
        state: {
          streamId: stream.id,
          videoId: stream.videoId,
          streamTitle: stream.streamTitle,
        },
      });

    }

    // ========================================================
    // UNKNOWN SOURCE
    // ========================================================

    else {
      Swal.fire({
        icon: "warning",
        title: "Invalid Stream",
        text: "Unknown stream source.",
      });
    }
  };

  // ============================================================
  // HANDLE DELETE
  // ============================================================

  const handleDelete = async (stream) => {
    const confirm = await Swal.fire({
      title: "Delete this stream?",
      text: "If the stream is live, deleting it may stop broadcasting.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    });

    if (!confirm.isConfirmed) {
      return;
    }

    try {
      setDeletingId(stream.uniqueId);

      let deleteUrl = "";

      // ========================================================
      // PRE-RECORDED DELETE
      // ========================================================

      if (stream.uploadType === "PRE-RECORDED") {
        deleteUrl = `${PRE_RECORDED_DELETE_API}/${stream.id}`;
      }

      // ========================================================
      // WEBCAM DELETE
      // ========================================================

      else if (stream.uploadType === "WEBCAM") {
        deleteUrl = `${WEBCAM_DELETE_API}/${stream.id}`;
      }

      if (!deleteUrl) {
        throw new Error("Invalid stream type");
      }

      // ========================================================
      // DELETE API CALL
      // ========================================================

      await axios.delete(deleteUrl, getAuthHeaders());

      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Stream removed successfully.",
      });

      // Refresh after deletion
      await fetchStreams();

    } catch (error) {
      console.error("Error deleting stream:", error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text:
          error.response?.data?.message ||
          "Could not delete the stream.",
      });

    } finally {
      setDeletingId(null);
    }
  };

  // ============================================================
  // FORMAT DATE
  // ============================================================

  const formatDate = (date) => {
    if (!date || !dayjs(date).isValid()) {
      return "-";
    }

    return dayjs(date).format("DD/MM/YYYY hh:mm A");
  };

  // ============================================================
  // STATUS BADGE COLOR
  // ============================================================

  const getStatusClass = (status) => {
    switch (status) {
      case "LIVE":
        return "bg-success";

      case "READY":
        return "bg-info";

      case "PUBLISHED":
        return "bg-warning";

      case "CANCELLED":
        return "bg-danger";

      default:
        return "bg-secondary";
    }
  };

  // ============================================================
  // JSX
  // ============================================================

  return (
    <div className="marquee-container">

      {/* ======================================================
          UPLOAD CONTENT BUTTON
      ======================================================= */}

      <div className="AddArea">

        <button
          type="button"
          className="btn btn-custom"
          onClick={() =>
            handleClick("/admin/upload-content")
          }
        >
          Upload Content
        </button>

      </div>

      <br />

      <div className="container3">

        {/* ====================================================
            BREADCRUMB
        ===================================================== */}

        <ol className="breadcrumb mb-4 d-flex my-0">

          <li className="breadcrumb-item text-white">
            Stream Management
          </li>

        </ol>

        <div className="outer-container">

          <div className="table-container">

            {/* ================================================
                STREAM MANAGEMENT TABLE
            ================================================= */}

            <table className="table table-striped">

              <thead>

                <tr className="table-header">

                  <th>
                    <input type="checkbox" />
                  </th>

                  <th>ID</th>

                  <th>SOURCE</th>

                  <th>STREAM NAME</th>

                  <th>START TIME</th>

                  <th>END TIME</th>

                  <th>STATUS</th>

                  <th>ACTION</th>

                </tr>

              </thead>

              <tbody>

                {/* ============================================
                    LOADING
                ============================================= */}

                {loading ? (

                  <tr>

                    <td
                      colSpan="8"
                      className="text-center"
                    >
                      Loading streams...
                    </td>

                  </tr>

                ) : streams.length > 0 ? (

                  /* ==========================================
                     DISPLAY BOTH STREAM TYPES
                  =========================================== */

                  streams.map((stream, index) => (

                    <tr
                      key={stream.uniqueId}
                      className={
                        index % 2 === 0
                          ? "even-row"
                          : "odd-row"
                      }
                    >

                      {/* CHECKBOX */}

                      <td>
                        <input type="checkbox" />
                      </td>

                      {/* SERIAL NUMBER */}

                      <td>
                        {index + 1}
                      </td>

                      {/* SOURCE */}

                      <td>
                        {stream.uploadType}
                      </td>

                      {/* STREAM TITLE */}

                      <td>
                        {stream.streamTitle}
                      </td>

                      {/* START TIME */}

                      <td>
                        {formatDate(stream.scheduleStart)}
                      </td>

                      {/* END TIME */}

                      <td>
                        {formatDate(stream.scheduleEnd)}
                      </td>

                      {/* STATUS */}

                      <td>

                        <span
                          className={`badge ${getStatusClass(
                            stream.status
                          )}`}
                        >
                          {stream.status}
                        </span>

                      </td>

                      {/* ACTION BUTTONS */}

                      <td>

                        {/* PLAY BUTTON */}

                        <button
                          type="button"
                          className="btn btn-sm me-2"
                          onClick={() => handlePlay(stream)}
                        >

                          <img
                            src={start}
                            alt="start"
                            style={{
                              width: "30px",
                              height: "30px",
                            }}
                          />

                        </button>

                        {/* DELETE BUTTON */}

                        <button
                          type="button"
                          className="btn btn-sm"
                          disabled={
                            deletingId === stream.uniqueId
                          }
                          onClick={() =>
                            handleDelete(stream)
                          }
                        >

                          <img
                            src={del}
                            alt="delete"
                            style={{
                              width: "30px",
                              height: "30px",
                            }}
                          />

                        </button>

                      </td>

                    </tr>

                  ))

                ) : (

                  /* ==========================================
                     NO STREAMS
                  =========================================== */

                  <tr>

                    <td
                      colSpan="8"
                      className="text-center"
                    >
                      No streams found
                    </td>

                  </tr>

                )}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>
  );
};

export default LiveStream;